import { useMutation } from '@tanstack/react-query'
import { useRef } from 'react'
import { useAuth } from '../providers'
import { v1Client } from '../api'
import { postTopUpPurchase } from './top-up-purchase'

/**
 * Hook to create a credit purchase for the user. Key lifecycle and error
 * shaping live in postTopUpPurchase.
 */
export const useAddCredits = () => {
  const { getAuthToken } = useAuth()
  const pendingKeys = useRef(new Map<string, string>())

  return useMutation({
    mutationFn: async (amountDollars: string) => {
      const token = await getAuthToken()
      return postTopUpPurchase(pendingKeys, {
        request: amountDollars,
        fallbackMessage: 'Failed to add credits. Please try again.',
        paymentMethodMessage: 'Failed to add credits. Please ensure you have a valid payment method.',
        post: (idempotencyKey) =>
          v1Client.POST('/billing/credits/top-ups', {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: {
              amountDollars,
              // Cast until gen:api-types picks up the deployed schema.
              idempotencyKey,
            } as { amountDollars: string },
          }),
      })
    },
    onSuccess: (_data, amountDollars) => {
      // Track the credit purchase
      window.ampltd.trackEvent('Add credits', {
        action: 'purchased',
        amount: amountDollars,
      })
    },
    onError: (error) => {
      console.error('Add credits error:', error)
      window.ampltd.trackEvent('Add credits', {
        action: 'error',
        error: error instanceof Error ? error.message : 'Unknown error',
      })
    },
  })
}
